import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getEditorialTeamOptions } from '@/module/Author/EditorialTeam';
import { EditorialTeamEdit } from '@/module/Author/EditorialTeam/EditorialTeamEdit';

export const Route = createFileRoute(
  '/_auth/author/_author/editorial-team/_editorialTeam/$editorialTeamId/_layout/edit',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { editorialTeamId } = Route.useParams();
  const { data: editorialTeam } = useSuspenseQuery(getEditorialTeamOptions(editorialTeamId));

  return <EditorialTeamEdit editorialTeam={editorialTeam} />;
}
